import {makeAction, makeAsyncAction} from 'common/utils/simplifiedAsync';

const ACTION_PREFIX = 'anodot/dnsTracker/';
const mac = (actionName) => makeAction(actionName, ACTION_PREFIX);
const macAsync = (actionName) => makeAsyncAction(actionName, ACTION_PREFIX);

export const fetchDnsTrackerData = macAsync('FETCH_DNS_TRACKER_DATA');
export const setPageKeyVal = mac('SET_DNS_TRACKER_KEY_VAL');
